import React from "react";
import { useTranslation } from "react-i18next";

export function H5 (props) {
    const { i18n } = useTranslation();
    return <h5>{i18n.t(props.label)}</h5>;
}
